import { useState } from 'react';
import { StyledLiveWebinar } from './LiveWebinar.styles';
import { Redirect } from 'react-router-dom';
export const LiveWebinar = () => {
	const [link] = useState(() => {
		const link = sessionStorage.getItem('webinar_link');
		if (link) {
			return link;
		}

		return '';
	});

	if (!link) return <Redirect to={'/dashboard'} />;
	return <StyledLiveWebinar src={link} allow="camera; microphone;fullscreen; allowfullscreen;"/>;
};
